import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrIcon } from "../icons";
import { GrBox, GrDivider, GrStack } from "../layout";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import { ListItemIcon, ListItemText, Menu, MenuItem, styled } from "@mui/material";
import classNames from "classnames";
const StyledListItemIcon = styled(ListItemIcon)(() => ({
    width: "100%",
    flexGrow: 1,
    flexBasis: "0px",
    alignSelf: "center",
}));
const StyledListItemText = styled(ListItemText)(({ size }) => ({
    width: "100%",
    flexGrow: 2,
    ".MuiTypography-root": {
        ...(size === "small" && { ...typography["Content.Subtitle04"] }),
        ...(size === "medium" && { ...typography["Content.Subtitle03"] }),
    },
    "&:hover": {
        TransitionEvent: "color 0.3s ease-in-out",
        color: palette.grey060,
    },
    "&:focus": {
        TransitionEvent: "color 0.3s ease-in-out",
        color: palette.grey060,
    },
}));
const StyledMenuItem = styled(MenuItem)(() => ({
    "&:focus": {
        backgroundColor: palette.white,
    },
    "&:hover": {
        backgroundColor: palette.white,
    },
    minWidth: "128px",
    padding: "10px 16px",
}));
const StyledMenuItemChildrenWrapper = styled("div")(() => ({
    padding: "15px",
}));
const StyledMenu = styled(Menu)(({ style, arrow }) => {
    const arrowPosition = arrow === null || arrow === void 0 ? void 0 : arrow.position;
    return {
        ".MuiPaper-root": {
            ...((arrowPosition === null || arrowPosition === void 0 ? void 0 : arrowPosition.vertical) === "top" && {
                "::before": {
                    // eslint-disable-next-line @typescript-eslint/quotes
                    content: '""',
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: "0 10px 8px",
                    borderColor: `${palette.white} transparent`,
                    width: 0,
                    zIndex: 1,
                    top: "-8px",
                    ...((arrowPosition === null || arrowPosition === void 0 ? void 0 : arrowPosition.horizontal) === "right" && { right: "8%" }),
                    ...((arrowPosition === null || arrowPosition === void 0 ? void 0 : arrowPosition.horizontal) === "left" && { left: "8%" }),
                },
            }),
            ...((arrowPosition === null || arrowPosition === void 0 ? void 0 : arrowPosition.vertical) === "bottom" && {
                "::after": {
                    // eslint-disable-next-line @typescript-eslint/quotes
                    content: '""',
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: "8px 10px 0",
                    borderColor: `${palette.white} transparent`,
                    width: 0,
                    zIndex: 1,
                    ...((arrowPosition === null || arrowPosition === void 0 ? void 0 : arrowPosition.horizontal) === "right" && { right: "8%" }),
                    ...((arrowPosition === null || arrowPosition === void 0 ? void 0 : arrowPosition.horizontal) === "left" && { left: "8%" }),
                },
            }),
        },
        ".MuiList-root": {
            padding: "4px 0px",
        },
        ...style,
    };
});
export function GrMenu({ size = "medium", anchorElement, position = { vertical: "top", horizontal: "left" }, style, arrow, onClose, className, ...props }) {
    const transformOrigin = {
        vertical: position.vertical === "top" ? "bottom" : "top",
        horizontal: position.horizontal,
    };
    const anchorOrigin = {
        vertical: position.vertical,
        horizontal: position.horizontal,
    };
    return (_jsx(StyledMenu, { className: classNames("GrMenu", className), transformOrigin: transformOrigin, anchorOrigin: anchorOrigin, anchorEl: anchorElement, open: !!anchorElement, onClose: onClose, slotProps: {
            paper: {
                elevation: 0,
                sx: {
                    borderRadius: "6px",
                    overflow: "visible",
                    filter: `drop-shadow(0px 2px 8px ${palette.black}1A)`,
                    transform: `translateY(${(arrow ? 16 : 8) * (position.vertical === "bottom" ? 1 : -1)}px) !important`,
                },
            },
        }, style: style, arrow: arrow, children: props.items.map((item, index) => {
            var _a;
            if (item.type === "item") {
                return (_jsx(StyledMenuItem, { disabled: props.disabled || item.disabled, disableRipple: true, onClick: e => {
                        if (item.onClick)
                            item.onClick(e, index);
                        if (onClose)
                            onClose();
                    }, children: _jsxs(GrStack, { flexDirection: "row", justifyContent: "space-around", alignItems: "center", width: "100%", gap: "5px", children: [item.icon && (_jsx(StyledListItemIcon, { children: _jsx(GrIcon, { size: 16, type: item.icon.type, color: (_a = item.icon.color) !== null && _a !== void 0 ? _a : "grey070", style: { height: "18px" } }) })), item.text && _jsx(StyledListItemText, { size: size, primary: item.text }), item.children && _jsx(StyledMenuItemChildrenWrapper, { children: item.children })] }) }, index));
            }
            else if (item.type === "divider") {
                return (_jsx(GrBox, { style: { padding: "0 16px" }, children: _jsx(GrDivider, { orientation: "horizontal", variant: "inset", spacing: 0.75, style: { borderColor: palette.grey020 } }, index) }, index));
            }
            return null;
        }) }));
}
//# sourceMappingURL=GrMenu.js.map